var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 2557"},[React.createElement("path",{"d":"M40.275 6H8a2 2 0 00-2 2v32.277a2 2 0 002 2h17.379V28.248h-4.712v-5.491h4.712v-4.041c0-4.686 2.861-7.237 7.041-7.237a38.765 38.765 0 014.224.216v4.9h-2.882c-2.274 0-2.715 1.081-2.715 2.667v3.5h5.438l-.709 5.491h-4.73v14.025h9.228a2 2 0 002-2V8a2 2 0 00-1.999-2zm0 0","fill":"#fff","key":0}),React.createElement("path",{"data-name":"Rectangle 693","fill":"none","d":"M0 0h48v48H0z","key":1})]));
}

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"5 5 38 38"};

module.exports = Facebook;

Facebook.default = Facebook;
